<div class="tn-loader-overlay" 
  [ngStyle]="{zIndex: loadingState.isShowingAlert ? '999' : '2000'}" 
  *ngIf="loadingState.isLoading">
  <i class="fa fa-spinner fa-pulse loading-icon fa-fw" *ngIf="loadingState.isShowSpinner"></i>
  <div class="loading-message">
    {{loadingState.message | translate}}
  </div>
  <button class="btn tn-button-primary btn-block refresh-btn" (click)="refreshSite()" *ngIf="loadingState.isReconnecting">
    {{'GENERAL.REFRESH' | translate}}
  </button>
</div>